import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../../shared/models/user.model';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  if (authService.currentUserValue) {
    return true;
  }
  
  // User is not logged in, redirect to login page
  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};

export const routeAccessGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.currentUserValue as any;

  const roleId = Number(user?.roleId);
  const role = String(user?.role || '').trim();
  const path = route.routeConfig?.path || '';
  let isAllowed = true;

  switch (path) {
    case 'userManagement':
      isAllowed = !(roleId === 4 || role === UserRole.DME_User);
      break;
    case 'serviceCenters':
      isAllowed = roleId === 3 || role === UserRole.DME_Admin;
      break;
    case 'concentrators':
    case 'patients':
    case 'concentrators/details':
    case 'patients/details': 
      isAllowed = !(roleId === 2 || role === UserRole.App_Admin) && !(roleId === 1 || role === UserRole.Super_Admin);
      break;  
    case 'organizations':
      isAllowed =
        roleId === 1 ||
        roleId === 2 ||
        role === UserRole.Super_Admin ||
        role === UserRole.App_Admin;
      break;
    case 'device-alerts':
      isAllowed =
        role !== UserRole.Patient &&
        !(roleId === 2 || role === UserRole.App_Admin) &&
        !(roleId === 1 || role === UserRole.Super_Admin);
      break;
    default:
      isAllowed = true;
      break;
  }

  if (!isAllowed) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};


// export const authGuard: CanActivateFn = async () => {
//   const auth = inject(AuthService);
//   const router = inject(Router);
//   const me = await auth.hydrate();
//   if (!me) {
//     router.navigateByUrl('/login');
//     return false;
//   }
//   return true;
// };